
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 24 24\" id=\"twitter\" ><title>twitter</title><g data-name=\"Layer 2\"><path d=\"M12 24a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-23a11 11 0 1 0 11 11A11 11 0 0 0 12 1z\"/><path d=\"M16.63 9.63v.31a6.79 6.79 0 0 1-10.45 5.72 5.1 5.1 0 0 0 .57 0 4.78 4.78 0 0 0 3-1A2.39 2.39 0 0 1 7.49 13a2.46 2.46 0 0 0 .45 0 2.41 2.41 0 0 0 .62 0 2.39 2.39 0 0 1-1.91-2.34 2.38 2.38 0 0 0 1.08.3A2.39 2.39 0 0 1 7 7.71a6.77 6.77 0 0 0 4.92 2.49A2.39 2.39 0 0 1 16 8a4.78 4.78 0 0 0 1.52-.58 2.39 2.39 0 0 1-1 1.32 4.77 4.77 0 0 0 1.37-.37 4.84 4.84 0 0 1-1.19 1.24\"/></g></symbol>";
module.exports = sprite.add(image, "twitter");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter.svg
// module id = 668
// module chunks = 1474